import useSetLoading from '@/hooks/useSetLoading';
import alertState from '@/states/alertState';
import introduceInfoState from '@/states/introduceInfoState';
import url from '@/utils/config';
import { ApiUrl } from '@/utils/constants';
import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import useCallAPIGetIntroduce from '@/hooks/api/useCallAPIGetIntroduce';
import Button from '@/components/atoms/Button';
import Heading from '@/components/atoms/Heading';
import { isExpiredToken } from '@/utils/cognito';

type Prop = {
  isOpen: boolean;
  onClose: () => void;
};

const IntroducerRewardsPopup = ({ isOpen, onClose }: Prop) => {
  // 同意
  const [agreement, setAgreement] = useState(false);
  // 送信ボタン押された
  const [processing, setProcessing] = useState(false);
  // 紹介者トークン発行APIフック
  const { execute: getIntroduce } = useCallAPIGetIntroduce();
  // loading
  const { startLoading, finishLoading } = useSetLoading();
  /** 取得したデータ */
  const setIntroduceInfo = useSetRecoilState(introduceInfoState);
  /** アラート */
  const setAlert = useSetRecoilState(alertState);

  /** 発行する */
  const callAPIPostIntroduce = async () => {
    try {
      startLoading(ApiUrl.Write.INTRODUCE_CREATE);
      const { data } = await getIntroduce();
      setIntroduceInfo((introduceInfo) => {
        return { ...introduceInfo, ...data };
      });
    } catch (error: any) {
      if (isExpiredToken(error)) {
        window.location.href = url('/login');
        sessionStorage.clear();
        return;
      }
      setAlert({
        isOpen: true,
        apiType: '',
      });
    } finally {
      finishLoading(ApiUrl.Write.INTRODUCE_CREATE);
      resetClose();
    }
  };

  /** モーダルを閉じる。その時に値をリセットする */
  const resetClose = () => {
    setProcessing(false);
    setAgreement(false);
    onClose();
  };

  /** 発行するをクリック */
  const onClickCreateCoupon = () => {
    setProcessing(true);
    callAPIPostIntroduce();
  };

  /** 同意チェック */
  const onChangeAgreement = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAgreement(e.target.checked);
  };

  /** 発行非活性 */
  const disableButton = () => {
    return !agreement || processing;
  };

  if (isOpen) {
    if (typeof window === 'object') {
      document.body.style.overflow = 'hidden';
    }
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
          <div className='m-modal__inner'>
            <div className='m-modal__content'>
              <Heading as='h3'>注意事項</Heading>
              <div className='m-text'>お友達紹介クーポンに関する注意事項をご確認ください。</div>
              <div className='border--coupon-rule'>
                <p className='m-text'>
                  ■特典内容
                  <br />
                  ＜ご紹介者様＞
                  <br />
                  1名ご紹介するごとにキャッシュバック
                  <br />
                  ※ご紹介可能な上限数は9名までとさせていただきます。
                  <br />
                  ※被紹介者様のお申し込みが完了した時点の特典内容が適用されます。
                  <br />
                  <br />
                  ＜ご紹介を受けた方（被紹介者様）＞
                  <br />
                  対象のお申し込み特典、キャンペーンに加えてさらにキャッシュバック
                  <br />
                  <br />
                  ■特典受取・適用方法
                  <br />
                  [STEP1]
                  <br />
                  被紹介者様のサービスご利用開始から3ヵ月後の15日に、ご紹介者様/被紹介者様それぞれのキャッシュバックがお受け取り可能となります。
                  <br />
                  お受け取り可能になりましたら、ご契約時にご登録いただいたメールアドレス宛に『受取り手続きのご案内』のお知らせメールを送信いたします。
                  <br />
                  <br />
                  [STEP2]
                  <br />
                  『 受取手続きのご案内
                  』のメールお受け取り後、キャッシュバック受取期間内に、NUROマイページより、お受け取り口座をご指定ください。
                  <br />
                  キャッシュバック受取手続き期間は45日間となります。メールお受け取り後、期間内にお手続きいただけなかった場合、無効となりますのでご注意ください。
                  <br />
                  ※キャッシュバックの受け取り手続きは、当日13時ごろから順次可能となります。
                  <br />
                  <br />
                  ■ご紹介者様の特典適用条件
                  <br />
                  以下の項目をすべて満たすことが条件です。条件に満たない場合、本特典の適用対象外となりますのでご注意ください。
                  <br />
                  <br />
                  ・本ページよりクーポンコードを発行後、被紹介者様がクーポンコードを入力の上、対象コースに申し込み、お申し込みから12カ月後の末日までにご利用開始されること。
                  <br />
                  ・被紹介者様が、ご利用開始2カ月後の末日時点で継続してご利用いただいていること。同じくその際、ご紹介者様のお支払い方法と連絡先メールアドレスが登録されている状態であること。
                  <br />
                  ・キャッシュバックのお受け取りまで、対象サービスを継続してご利用いただくこと。
                  <br />
                  ※キャッシュバックのお受け取りが可能になるまで、「NURO
                  光」を継続してご利用ください。キャッシュバックのお受け取り前にキャンセルおよび解約をされた場合は対象外となります。
                  <br />
                  <br />
                  <br />
                  ■注意事項等
                  <br />
                  ※ ご紹介者様1人あたりご紹介可能な上限人数は9名までとなります。
                  発行されたクーポンコードが9回ご利用された時点で、10回目以降のクーポンコード入力分は無効となります。
                  <br />
                  ※
                  クーポンコードの有効期限は10年間となります。有効期限が過ぎた場合、クーポンコードのご利用はできません。
                  <br />
                  ※ ご紹介者様と被紹介者様が同一の場合は、特典適用対象外となります。
                  <br />
                  ※
                  弊社が適当でないと判断する方法により本特典を利用された場合、予告なく特典の取り消し、及び既にお受け取り済み特典をご返却いただく場合がございます。
                  <br />
                  ※ 被紹介者様のNURO
                  光お申し込み状況等に関するご紹介者さまからのお問い合わせにはお答えできかねます。
                  <br />
                  ※
                  キャッシュバックのお受け取り手続き完了後、お申し込み時にご登録いただきましたメールアドレス宛にソニーネットワークコミュニケーションズから送金完了した旨をご連絡させていただきます。
                  <br />
                  ※ 一部の金融機関への振込は行えませんので、予めご了承ください。
                  <br />
                  ※ 本特典は予告なく終了・変更させていただく場合があります。予めご了承ください。
                  <br />
                  ※ 消費税率が変更されても、キャッシュバック金額の変更はございません。
                  <br />
                  <br />
                </p>
              </div>
            </div>
            <div className='m-modal__footer'>
              {/* 同意チェック */}
              <div className='m-form-checkbox'>
                <input
                  className='mgr-10px'
                  type='checkbox'
                  id='agreement-coupon'
                  data-testid='agreement-coupon'
                  onChange={onChangeAgreement}
                />
                <label htmlFor='agreement-coupon' className='m-text'>
                  すべての注意事項をご確認の上、同意する場合はチェックを入れてください
                </label>
              </div>
              {/* 発行するボタン */}
              <div className='m-button align-center'>
                <Button variant='primary' onClick={onClickCreateCoupon} disabled={disableButton()}>
                  発行する
                </Button>
              </div>
            </div>
            <button
              type='button'
              onClick={resetClose}
              className='m-modal__closeButton js-modal-coseButton'
            >
              <img
                className='m-modal__closeButtonImage'
                src={url('/images/icon_close.svg')}
                alt='閉じる'
                width='40'
                height='40'
              />
            </button>
          </div>
        </div>
        <span
          role='button'
          tabIndex={0}
          className='fn-overlay is-overlay-show'
          onClick={resetClose}
          onKeyDown={resetClose}
          aria-label='閉じる'
          data-testid='show'
        />
      </>
    );
  }
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }

  return <span className='fn-overlay' data-testid='hidden' />;
};

export default IntroducerRewardsPopup;
